import React, { useState } from 'react';
import { Autocomplete, Button, IconButton, Switch, TextField, Typography } from '@mui/material';
import { PatientInfoList } from '../PatientFormContainer/pages/PatientInfoPage/components/PatientInfoList';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { ArrowRightIcon } from "@mui/x-date-pickers";
import CancelIcon from '@mui/icons-material/Cancel';
import TextLanguage from '../../data/TextLanguage.json';
import { StyledPopper } from '../../pages/ChatPage';
import { useTheme } from '@mui/material/styles';
import { useUpdateConvCaseMutation } from './hooks/useUpdateConvCaseMutation';
import { usePatientsQuery } from '../../hooks/usePatientsQuery';
import { clamp } from 'lodash';
export const WhatsappConversationCaseSelection = ({
    lang,
    setsnackbarStatus,
    whatsappQueryData,
    selectedChat
}) => {

    const theme = useTheme();

    const [searchMode, setSearchMode] = useState('RBK');
    const isConversationAssigned = whatsappQueryData?.data[selectedChat]?.RBKCaseNo ? true : false;
    const getYear = new Date().getFullYear();
    const [LDMCaseNoYear, setLDMCaseNoYear] = useState(getYear);
    const handleLDMYearInc = (i) => () => {
        const setYear = clamp(LDMCaseNoYear + i, getYear - 1, getYear);
        setLDMCaseNoYear(setYear);
    };
    const searchFilter = (searchInput, LDMCaseNoYear) => {
        return (([undefined, 'undefined', null, 'null'].includes(searchInput)) ?
            {}
            :
            searchMode === 'RBK' ?
                { caseNumber: searchInput }
                :
                { LDMCaseNoInt: searchInput, LDMCaseNoYear: LDMCaseNoYear });
    };
    const updateConvMutation = useUpdateConvCaseMutation({ setsnackbarStatus });

    const [patientSearchInput, setPatientSearchInput] = useState({ caseNumber: undefined, LDMCaseNoInt: undefined });
    const singlePatientQuery = usePatientsQuery({ disableClick: false, page: 0, pageSize: 1, sortField: null, sortOrder: null, searchFilter: searchFilter(whatsappQueryData?.data[selectedChat]?.caseNumber || patientSearchInput?.caseNumber) });
    const searchPatientQuery = usePatientsQuery({
        disableClick: false, page: 0, pageSize: 1, sortField: null, sortOrder: null,
        enabled: (searchMode === 'RBK' ? !!patientSearchInput?.caseNumber : !!patientSearchInput?.LDMCaseNoInt),
        searchFilter: searchFilter(searchMode === 'RBK' ? patientSearchInput?.caseNumber : patientSearchInput?.LDMCaseNoInt, LDMCaseNoYear)
    });
    const queryCaseNoList = searchPatientQuery?.data?.data?.patientList?.map((patient) => {
        return (
            {
                RBKCaseNo: patient?.RBKCaseNo,
                caseNumber: patient?.caseNumber,
                LDMCaseNoInt: patient?.LDMCaseNoInt,
                LDMCaseNo: patient?.LDMCaseNo

            }
        )
    }) || [];

    const handleAutocompleteChange = (event, newInputValue) => {
        const newValue = searchMode === 'RBK' ? { caseNumber: newInputValue } : { LDMCaseNoInt: newInputValue };
        setPatientSearchInput(newValue)
    }
    const handleAssignToConversation = () => {
        updateConvMutation.mutate({
            RBKCaseNo: searchPatientQuery?.data?.data?.patientList[0]?.RBKCaseNo,
            phoneNumber: whatsappQueryData?.data[selectedChat]?.conversation
        })


    }








    return (<div style={{
        background: '#353535',
        borderLeft: `1px solid black`,
        boxShadow: `inset 0px 0px 20px 0px ${theme.palette.shadow[1]}`
    }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{
                width: '100%', padding: '1rem',
                background: theme.palette.gradient.d,
                boxShadow: `inset 0px 0px 20px 0px ${theme.palette.shadow[1]}`,
                borderBottom: `1px solid ${theme.palette.light[3]}`
            }}>
                <Typography sx={{ pointerEvents: 'none', userSelect: 'none' }}> {isConversationAssigned ?
                    TextLanguage["ConnectedPatientCase"][lang]
                    :
                    TextLanguage["AssignToPatientCase"][lang]}</Typography>
            </div>
            <div className='CaseSearchAutocompleteWrapper'>

                <Autocomplete
                    sx={{
                        '.MuiFormControl-root': {
                            width: '100%', background: theme.palette.dark[4], color: 'white', borderRadius: 0, border: 'none'
                        }
                    }}
                    className="CaseSearchAutocomplete"

                    onInputChange={handleAutocompleteChange}
                    // onChange={(event, value) => { setPatientSearchInput(value) }}
                    size="small"

                    value={patientSearchInput}
                    PopperComponent={StyledPopper}
                    getOptionLabel={(option) => searchMode === 'RBK' ? `${option?.caseNumber || ''}` : `${option?.LDMCaseNoInt || ''}`}
                    options={queryCaseNoList}
                    isOptionEqualToValue={(option, value) => searchMode === 'RBK' ? option?.caseNumber === value : option?.LDMCaseNoInt === value}
                    // ListboxComponent={ListboxComponent}
                    noOptionsText={"No Matches"}
                    renderOption={(props, option) => {
                        return (
                            <li {...props} key={option?.RBKCaseNo} style={{ display: 'flex', alignItems: 'center', padding: '0.5rem 1rem' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Typography sx={{ color: 'white', fontSize: '0.8rem', fontWeight: 'bold' }}>
                                        {searchMode === 'RBK' ? option?.RBKCaseNo : option?.LDMCaseNo}
                                    </Typography>

                                </div>
                            </li>)
                    }}
                    renderInput={(params) => <TextField {...params}
                        sx={{
                            background: theme.palette.gradient.a, color: 'white', borderRadius: 0, border: 'none',
                            '& .MuiInputBase-root': {
                                background: theme.palette.gradient.d,
                                margin: 0, padding: 0,
                                '& .MuiInputBase-input': {
                                   padding: '0 !important',
                                }
                            },
                        }}
                        placeholder={'####'}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <>
                                    <InputAdornment sx={{ p: 0, m: 0 }} position="start">
                                        <SearchIcon sx={{ margin: '0.2rem' }} />

                                        {searchMode !== 'RBK' &&
                                            <>
                                                <IconButton
                                                    sx={{ transform: 'rotate(180deg)', paddingInline: '0px 0.5rem' }}
                                                    disableRipple
                                                    onClick={handleLDMYearInc(-1)}
                                                    edge="start"
                                                >
                                                    <ArrowRightIcon />
                                                </IconButton>
                                                <IconButton
                                                    sx={{ paddingInline: '0px 0.75rem' }}
                                                    disableRipple
                                                    onClick={handleLDMYearInc(1)}
                                                    edge="end"
                                                >
                                                    <ArrowRightIcon />
                                                </IconButton>




                                            </>}
                                        <Typography sx={{ fontWeight: 'bold', color: 'darkgray', m: 0 }}>
                                            {searchMode === 'RBK' ? 'RBK' : `TUR${LDMCaseNoYear}-`}
                                        </Typography>

                                    </InputAdornment>
                                    {params.InputProps.startAdornment}
                                </>
                            )
                        }}
                        variant="outlined" />} />

                <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    width: '100%', padding: '0.5rem 1rem', background: theme.palette.gradient.d,
                    boxShadow: `inset 0px 0px 20px 0px ${theme.palette.shadow[1]}`,
                    border: `1px solid ${theme.palette.shadow[2]}`, borderRadius: '0px 0px 12px 12px',
                    borderTop: 'none',
                    flexDirection: 'row'
                }}>
                    <div style={{
                        display: 'flex', alignItems: 'center', flexDirection: 'row'
                    }}>
                        <Typography sx={{ color: searchMode !== 'RBK' ? 'white' : 'grey', fontSize: '0.8rem', fontWeight: 'bold', marginRight: '0.5rem' }}>
                            {'LDM'}
                        </Typography>
                        <Switch
                            checked={searchMode === 'RBK'}
                            onChange={(event) => setSearchMode(prev => prev === 'RBK' ? 'LDM' : 'RBK')}
                            color='default'
                        />
                        <Typography sx={{ color: searchMode === 'RBK' ? 'white' : 'grey', fontSize: '0.8rem', fontWeight: 'bolder', marginRight: '0.5rem' }}>
                            {'RBK'}
                        </Typography>
                    </div>
                    <Button
                        onClick={handleAssignToConversation}
                        sx={{
                            borderRadius: 0,
                            padding: '4px 16px !important',
                            background: theme.palette.gradient.a,
                            color: 'white',
                            '&:hover': {
                                boxShadow: `inset 0px 0px 12px -2px ${theme.palette.buttonGlow[3]}`,
                                background: theme.palette.gradient.a,
                                outline: 'none',
                                border: 'none',
                                filter: 'brightness(1.25) contrast(1.1)',
                            },
                        }}>
                        {isConversationAssigned ? TextLanguage["Reassign"][lang] : TextLanguage["Assign"][lang]}
                    </Button>
                </div>




            </div>


            {isConversationAssigned && singlePatientQuery?.data?.data?.patientList[0] && <>

                <div className='patientInfoHeader'>
                    <Typography sx={{ color: 'white', fontSize: '1rem', fontWeight: 'bold' }}>
                        {`${searchMode === 'RBK' ?
                            singlePatientQuery?.data?.data?.patientList[0]?.RBKCaseNo
                            :
                            singlePatientQuery?.data?.data?.patientList[0]?.LDMCaseNo
                            ||
                            singlePatientQuery?.data?.data?.patientList[0]?.RBKCaseNo
                        }`}
                    </Typography>

                </div>

                <PatientInfoList
                    lang={lang}
                    selectedRow={singlePatientQuery?.data?.data?.patientList[0]}
                    selectedhospCaseUserID={null}
                    selectedhospCaseHospID={null}
                    onRowFileURLs={null}
                    setselectedRow={null}
                    opMode={true}
                    setsnackbarStatus={setsnackbarStatus} />
            </>}


        </div>
    </div>);
}
